import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_2 = { class: "px-3 py-2 text-sm text-white rounded w-max bg-primary-600" }
const _hoisted_3 = { class: "px-0.5 py-6 text-sm text-center text-gray-900" }
const _hoisted_4 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_5 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_6 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_7 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_8 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_9 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_10 = { class: "px-0.5 py-6 text-sm text-gray-900" }
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-center mx-auto"
}
const _hoisted_12 = {
  key: 1,
  class: "flex items-center justify-center mx-auto shrink-0"
}

import { ref, type PropType, computed, Component } from "vue";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import DateDetail from "@/components/partials/DateDetail.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import { TrashIcon } from "@heroicons/vue/24/solid";
import { useRouter, useRoute } from "vue-router";
import { InterventionItems } from "@/interfaces/Cases/Interevention";
import InterventionService from "@/classes/Cases/InterventionService";
import { errorResponse } from "@/helpers/errorMessage";
import { InterventionType } from "@/views/enums/InterventionType";
import pickBy from "lodash/pickBy";
import { useNetworkStore } from "@/store/network";
import { PlusIcon } from "@heroicons/vue/24/outline";

import EditButton from "@/components/buttons/EditButton.vue";
import ViewButton from "@/components/buttons/ViewButton.vue";
import DeleteButton from "@/components/buttons/DeleteButton.vue";
import RestoreButton from "@/components/buttons/RestoreButton.vue";

import SocialWorkIcon from "@/components/icons/socialWorkIcon.vue";
import MentalHealthIcon from "@/components/icons/mentalHealthIcon.vue";
import DevelopmentalPediaIcon from "@/components/icons/developmentalPediaIcon.vue";
import LegalIcon from "@/components/icons/legalIcon.vue";

import DateFormatter from "@/helpers/DateFormatter";


export default /*#__PURE__*/_defineComponent({
  __name: 'InteventionTable',
  props: {
	typeTwo: {
		type: Boolean,
		default: false,
	},
	interventionType: {
		type: String,
		default: null,
	},
	caseNumber: {
		type: String,
		default: null,
	},
	doneBy: {
		type: String,
		default: null,
	},
	doneOn: {
		type: String,
		default: null,
	},
	status: {
		type: String,
		default: "Scheduled", // Scheduled | Past Due | Done
	},
	item: {
		type: Object as PropType<InterventionItems>,
		required: true,
	},
},
  emits: ['update:refresh'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
const route = useRoute();
const patientId = ref<number>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const selectedId = ref<number|null>(null);
const deleteSuccessMessage = ref<string>("Selected record has been successfully deleted.");
const restoreSuccessMessage = ref<string>("Selected record has been successfully restored.");

const props = __props;

const emit = __emit;

const showConfirmation = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const showRestoreConfirmation = ref<boolean>(false);
const showRestoreSuccess = ref<boolean>(false);
const errors = ref<object | null>(null);

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);
const offlineParams = ref<string>(route.query.offline);
const selectedItemId = computed(() => props.item.id ?? props.item?.offlineData?.offline_id);

const editRoute = (item:any): string => {
    if(caseId?.value){
        return `/patient/${item.patient_id}/cases/${item.cases_id}/intervention/${item.intervention_type}/edit/${item.id}`;
    } else {
        return `/patient/${item.patient_id}/intervention/${item.intervention_type}/edit/${item.id}`;
    }
}

const removeConfirmation = (item: number): void => {
    selectedItemId.value = item,
    showConfirmation.value = true
}

const remove = (): void => {
	showConfirmation.value = false;
	InterventionService.delete(
		patientId.value,
		undefined,
		selectedItemId.value,
		pickBy({ isOfflineData: offlineParams.value ? true : false }),
		isNetworkAvailable.value
	)
	.then((response: object) => {
		showSuccess.value = true;
		deleteSuccessMessage.value = response.data.message;
	})
	.catch((error: object) => {
		console.log(error)
		errors.value = errorResponse(error.response?.data?.errors);
	});
};

const showRestoreModal = (item: any): void => {
    showRestoreConfirmation.value = true;
    selectedId.value = item.id;
}

const restore = (): void => {
	showRestoreConfirmation.value = false;
	InterventionService.restore(patientId.value, caseId.value, selectedId.value, {})
		.then((response: object) => {
			showRestoreSuccess.value = true;
			restoreSuccessMessage.value = response.data.message;
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		});
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
    emit('update:refresh');
};

const redirectRestoreSuccess = (): void => {
	showSuccess.value = false;
	showRestoreSuccess.value = false;
        
    let url = '';
    
    if(caseId?.value){
        url = `/patient/${patientId.value}/cases/${caseId.value}/interventions`;
    } else {
        url = `/intervention/${patientId.value}/view`;
    }

    window.location.replace(url);
};

const fetchInterventionIcon = (intervention:number): Component|null => {
    switch (intervention) {
        case InterventionType.SOCIAL_WORK:
            // return  "/assets/icon/intervention/ic-social-work.svg"
            return  SocialWorkIcon;
        case InterventionType.MENTAL_HEALTH:
            // return  "/assets/icon/intervention/ic-mental-health.svg"
            return  MentalHealthIcon
        case InterventionType.DEVELOPMENT_PEDIA:
            // return  "/assets/icon/intervention/ic-developmental-pedia.svg"
            return  DevelopmentalPediaIcon
        case InterventionType.LEGAL:
            // return  "/assets/icon/intervention/ic-legal.svg"
            return  LegalIcon
        default:
            return null;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", null, [
      _createElementVNode("td", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(DateFormatter).customDateFormat(__props.item.schedule_date, "MMM dd, yyy - hh:mm a ")), 1)
      ]),
      _createElementVNode("td", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-max flex rounded py-[7px] px-4 font-semibold text-xs text-white transition", __props.item?.done_on ? 'bg-neutral-400' : 'bg-[#82c0cf]'])
        }, [
          (fetchInterventionIcon(__props.item.intervention_type))
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(fetchInterventionIcon(__props.item.intervention_type)), {
                key: 0,
                class: "object-contain w-4 h-4 mr-1 -ml-2 icon"
              }))
            : (_openBlock(), _createBlock(_unref(PlusIcon), {
                key: 1,
                class: "w-4 h-4 stroke-[3px] -ml-2 mr-1 icon"
              })),
          _createElementVNode("span", null, _toDisplayString(__props.item.intervention_type_name), 1)
        ], 2)
      ]),
      _createElementVNode("td", _hoisted_4, _toDisplayString(__props.item.type), 1),
      _createElementVNode("td", _hoisted_5, _toDisplayString(__props.item?.subtype ?? '-'), 1),
      _createElementVNode("td", _hoisted_6, _toDisplayString(__props.item.case_number), 1),
      _createElementVNode("td", _hoisted_7, _toDisplayString(__props.item.done_by), 1),
      _createElementVNode("td", _hoisted_8, _toDisplayString(__props.item?.done_on ? _unref(DateFormatter).customDateFormat(__props.item.done_on, "MMM dd, yyy - hh:mm a ") : '-'), 1),
      _createElementVNode("td", _hoisted_9, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-xs font-semibold px-2 py-1 leading-[18px] rounded-lg text-white mr-2 text-center", 
                    __props.item.status == 'Scheduled' ? 'bg-green-600' : __props.item.status == 'Past Due' ? 'bg-red-600' : 'bg-primary-600'
                ])
        }, _toDisplayString(__props.item.status), 3)
      ]),
      _createElementVNode("td", _hoisted_10, [
        (_unref(route).query.tab !== 'archived')
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createVNode(EditButton, {
                class: "shrink-0",
                routeLink: editRoute(__props.item)
              }, null, 8, ["routeLink"]),
              (__props.item.status !== 'Done')
                ? (_openBlock(), _createBlock(DeleteButton, {
                    key: 0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (removeConfirmation(__props.item))),
                    class: "shrink-0"
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(RestoreButton, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showRestoreModal(__props.item)))
              })
            ]))
      ])
    ]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showConfirmation.value,
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (showConfirmation.value = false)),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (remove())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Delete Record?",
      content: "Are you sure you wish to delete this record?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showSuccess.value,
      onConfirm: _cache[4] || (_cache[4] = ($event: any) => (redirectSuccess())),
      "action-text": "Close",
      title: "Record Deleted!",
      content: deleteSuccessMessage.value
    }, null, 8, ["show", "content"]),
    _createVNode(ConfirmationModal, {
      typeTwo: true,
      show: showRestoreConfirmation.value,
      onCancel: _cache[5] || (_cache[5] = ($event: any) => (showRestoreConfirmation.value = false)),
      onConfirm: _cache[6] || (_cache[6] = ($event: any) => (restore())),
      "cancel-text": "Cancel",
      "action-text": "Confirm",
      title: "Restore Record?",
      content: "Are you sure you wish to restore this record?"
    }, null, 8, ["show"]),
    _createVNode(SuccessModal, {
      show: showRestoreSuccess.value,
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (redirectRestoreSuccess())),
      "action-text": "Close",
      title: "Record Restored!",
      content: restoreSuccessMessage.value
    }, null, 8, ["show", "content"])
  ], 64))
}
}

})